document.addEventListener("DOMContentLoaded", function () {
  var mapElement = document.getElementById("custom-map");

  if (!mapElement || typeof L === "undefined") {
    return;
  }

  var locationLat = 48.0169;
  var locationLng = 9.8175;

  var map = L.map("custom-map", {
    center: [locationLat, locationLng],
    zoom: 13,
    zoomControl: false,
    scrollWheelZoom: false,
    attributionControl: false
  }); 

  L.control.zoom({
    position: "topright"
  }).addTo(map);

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19
  }).addTo(map);

  var customIcon = L.divIcon({
    className: "",
    html: '<div class="custom-map-pin"></div>',
    iconSize: [34, 34],
    iconAnchor: [17, 34]
  });

  L.marker([locationLat, locationLng], {
    icon: customIcon
  }).addTo(map);
});

(function ($) {
  $(function () {

      // AOS
    AOS.init();

    /* 
     * Header overlay menu
     */
    const $body = $('body');
    const $menuButtons = $('.menu-btn-burger');
    const $overlayMenu = $('.site-navigation-overlay');
    const $closeButtons = $('.site-navigation-overlay__backdrop');

    function openOverlayMenu() {
      $body.addClass('navigation-open');
      $overlayMenu.addClass('is-open').attr('aria-hidden', 'false');
      $menuButtons.attr({
        'aria-expanded': 'true',
        'aria-label': 'Close menu'
      });
    }

    function closeOverlayMenu() {
      $overlayMenu.removeClass('is-open').attr('aria-hidden', 'true');
      $menuButtons.attr({
        'aria-expanded': 'false',
        'aria-label': 'Open menu'
      });

      window.setTimeout(function () {
        if (!$overlayMenu.hasClass('is-open')) {
          $body.removeClass('navigation-open');
        }
      }, 380);
    }

    $menuButtons.on('click', function (e) {
      e.preventDefault();
      if ($overlayMenu.hasClass('is-open')) {
        closeOverlayMenu();
        return;
      }

      openOverlayMenu();
    });

    $closeButtons.on('click', function (e) {
      e.preventDefault();
      closeOverlayMenu();
    });

	    $(document).on('keydown', function (e) {
	      if (e.key === 'Escape') {
	        closeOverlayMenu();
	      }
	    });

	    /*
	     * Smooth scroll for in-page anchors
	     */
	    $('a[href*="#"]').on('click', function (e) {
	      var href = this.getAttribute('href');
	      var hash = this.hash;
	      var isBootstrapTrigger = $(this).is('[data-bs-toggle], [data-toggle], [data-bs-target], [data-target]');
	      var isSamePageLink = this.pathname.replace(/^\//, '') === window.location.pathname.replace(/^\//, '') &&
	        this.hostname === window.location.hostname;

	      if (!href || href === '#' || !hash || isBootstrapTrigger || !isSamePageLink) {
	        return;
	      }

	      var $target = $(hash);

	      if (!$target.length) {
	        $target = $('[name="' + hash.slice(1) + '"]');
	      }

	      if (!$target.length) {
	        return;
	      }

	      e.preventDefault();

	      $('html, body').animate({
	        scrollTop: $target.offset().top
	      }, 800);
	    });

	    /*
	     * Owl carousel
	     */
	    $('.owl-room-card').owlCarousel({
      margin: 40,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: true,
      dots: false,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    /*
     * Video modal
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function () {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function () {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });

    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false,
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });

    /*
     * Reference filter
     */
    $('[data-reference-filter]').each(function () {
      var $filter = $(this);
      var $buttons = $filter.find('.reference-filter__button');
      var $items = $filter.find('[data-reference-item]');
      var $grid = $filter.find('[data-reference-grid]');

	        $buttons.on('click', function () {
	          var filter = $(this).data('filter');
	
	          $buttons.removeClass('is-active').attr('aria-selected', 'false');
	          $(this).addClass('is-active').attr('aria-selected', 'true');

        $grid.toggleClass('is-filtered', filter !== 'all');

	          $items.each(function () {
	            var terms = ($(this).attr('data-term') || '').split(/\s+/).filter(Boolean);
	            var matches = filter === 'all' || terms.indexOf(filter) !== -1;
	            $(this).toggleClass('is-hidden', !matches);
	          });

	          if (typeof AOS !== 'undefined') {
	            AOS.refreshHard();
	          }
	        });
	      });
	  });
	})(jQuery);
